import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useHttpRequest from '../../../../CustomHooks/useHttpRequest/useHttpRequest';
import { selectUserActivityResult } from '../../redux/userActivity.slice';

function ActivityLogger() {
  const userActivity = useSelector(selectUserActivityResult);

  const { heartbeatRequest } = useHttpRequest();

  useEffect(() => {
    const noDate = !userActivity.createdAt;
    if (noDate) return;

    const currentTime = new Date();
    const timeDifferenceInMinutes = (currentTime - userActivity.createdAt) / 1000 / 60;

    if (timeDifferenceInMinutes < 45) {
      heartbeatRequest(userActivity.logType);
      if (window.restartSessionTimeOut) {
        window.restartSessionTimeOut();
      }
    }
  }, [userActivity.createdAt]);

  return null;
}

export default ActivityLogger;
